//时间转换
function tsToTime (timestamp, hasSecond = true) {
    let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let format = "yyyy.MM.dd hh:mm";
    if (hasSecond) {
        format += ":ss";
    }
    return date.format(format);
}
function calcPrice (price) {
    if (!price) price = 0;
    return (price / 100).toFixed(2);
}
function dislodgeZero(str) {
    let strArray = str.split("/");
    strArray = strArray.map(function(val) {
        if (val[0] == "0") {
        return (val = val.slice(1));
        } else {
        return val;
        }
    });
    return strArray.join(".");
}
function getWeek (timeStamp) {
    var date = new Date(timeStamp * 1000);
    var day = date.getDay();
    if (day == 0) {
        return '周日';
    } else if (day == 1) {
        return '周一';
    } else if (day == 2) {
        return '周二';
    } else if (day == 3) {
        return '周三';
    } else if (day == 4) {
        return '周四';
    } else if (day == 5) {
        return '周五';
    } else if (day == 6) {
        return '周六';
    }
    return '';
}
// 时间长度
function timeMeter (t, type = 1) {
    let time = Number(t);
    let h = time / 3600 < 10 ? "0" + parseInt(time / 3600) : parseInt(time / 3600);
    if (h != '00') time = time - h * 3600;
    let m = time / 60 < 10 ? "0" + parseInt(time / 60) : parseInt(time / 60);
    let s = time % 60 < 10 ? "0" + (time % 60) : time % 60;
    if (type == 1) {
        return h + ':' + m + ":" + s;
    } else if (type == 2) {
        return m + "分" + s + "秒";
    }
}

// 2019-6-24
function timestampToDay (timestamp) {
    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-';
    var M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '-';
    var D =
        date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
    return Y + M + D;
}

/**
 * 时间戳 => 10-10
 * */
function timestampToMD (timestamp) {
    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '.';
    var D =
        (date.getDate() + 1 < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    return M + D;
}

/**
 * 时间戳 => 10:10
 * */

function timestampToHM (timestamp) {
    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var h =
        (date.getHours() + 1 < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var m =
        date.getMinutes() + 1 < 10 ? '0' + date.getMinutes() : date.getMinutes();
    // var s = (date.getSeconds() + 1 < 10 ? '0' + date.getSeconds() : date.getSeconds())
    return h + m;
    // return Y + M + D;
}

/**
 * 时间戳 =>判断时间戳区间（ 0:今年不跨日 / 1:今年跨日 / 2:往年不跨日 / 3:往年跨日 / 4：跨年 ）
 * */
function time_judge (time_start, time_end) {
    var time_s = new Date(time_start * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var time_e = new Date(time_end * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var today = new Date(); //当前时间
    var Y_s = time_s.getFullYear() + '.';
    var Y_e = time_e.getFullYear() + '.';
    var Y_n = today.getFullYear() + '.';
    var M_s =
        (time_s.getMonth() + 1 < 10 ?
            '0' + (time_s.getMonth() + 1) :
            time_s.getMonth() + 1) + '.';
    var M_e =
        (time_e.getMonth() + 1 < 10 ?
            '0' + (time_e.getMonth() + 1) :
            time_e.getMonth() + 1) + '.';
    var D_s =
        (time_s.getDate() + 1 < 10 ? '0' + time_s.getDate() : time_s.getDate()) +
        ' ';
    var D_e =
        (time_e.getDate() + 1 < 10 ? '0' + time_e.getDate() : time_e.getDate()) +
        ' ';
    //判断
    if (Y_s == Y_e) {
        //同年
        if (Y_s == Y_n) {
            //今年
            if (M_s == M_e && D_s == D_e) {
                //今年不跨日
                return 0;
            } else {
                //今年跨日
                return 1;
            }
        } else {
            //往年
            if (M_s == M_e && D_s == D_e) {
                //往年不跨日
                return 2;
            } else {
                //往年跨日
                return 3;
            }
        }
    } else {
        //跨年
        return 4;
    }
}

// 获取时间跨度
function getDuration (start_date, end_date) {
    let dateStr;
    // 0:今年不跨日 / 1:今年跨日 / 2:往年不跨日 / 3:往年跨日 / 4：跨年
    const type = time_judge(start_date, end_date);
    switch (type) {
        case 0: {
            dateStr =
                timestampToMD(start_date) +
                timestampToHM(start_date) +
                ' - ' +
                timestampToHM(end_date);
        }
            break;
        case 1: {
            dateStr =
                timestampToMD(start_date) +
                timestampToHM(start_date) +
                ' - ' +
                timestampToMD(end_date) +
                timestampToHM(end_date);
        }
            break;
        case 2: {
            dateStr =
                timestampToDay(start_date) +
                timestampToHM(start_date) +
                ' - ' +
                timestampToHM(end_date);
        }
            break;
        case 3: {
            dateStr =
                timestampToDay(start_date) +
                timestampToHM(start_date) +
                ' - ' +
                timestampToMD(end_date) +
                timestampToHM(end_date);
        }
            break;
        case 4: {
            dateStr =
                timestampToDay(start_date) +
                timestampToHM(start_date) +
                ' - ' +
                timestampToDay(end_date) +
                timestampToHM(end_date);
        }
            break;
        default:
            dateStr = '不支持的时间格式';
            break;
    }
    return dateStr;
}

// 防抖
function debounce (func, wait) {
    let timer;
    return function () {
        let context = this;
        let args = arguments;
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(context, args)
        }, wait);
    }
}

// 节流
function throttle (func, wait) {
    let timer;
    return function () {
        let context = this;
        let args = arguments;
        if (timer) return;
        timer = setTimeout(() => {
            timer = null;
            func.apply(context, args);
        }, wait);
    };
}

// 获取字母序号 number >= 1
function getLetterNumber (number) {
    return String.fromCharCode(64 + number);
}

function toFixed (num, s) {
    var times = Math.pow(10, s)
    var des = num * times + 0.5
    des = parseInt(des, 10) / times
    return des + ''
}

// 数组元素交换
function swapArrayItem (arr, fromIndex, toIndex) {
    arr[toIndex] = arr.splice(fromIndex, 1, arr[toIndex])[0];
    return arr;
}

// 提取数组指定key，并拼接成字符串
function joinArray (arr, key, split = ',') {
    const retAry = [];
    arr && arr.length && arr.forEach(i => {
        retAry.push(i[key]);
    })
    return retAry.join(split);
}

// 获取当前时间戳，单位秒
function getCurTimestamp () {
    return parseInt(new Date().getTime() / 1000);
}

// 将对象第一级属性全部重置为空字符串
// obj - 待处理对象     exceptKeyAry - 排除的键值数组    val - 重置的值
function clearObj (obj, exceptKeyAry = [], val = "") {
    for (const key in obj) {
        if (exceptKeyAry.includes(key)) continue;
        obj[key] = val;
    }
}

// 停止body滚动
function stopBodyScroll (isStop) {
    let ele = document.documentElement;
    if (isStop) {
        ele.style['overflow-y'] = "hidden";
    } else {
        ele.style['overflow-y'] = "scroll";
    }
}

function appendJs (js) {
    if (!js) {
        return;
    }
    if (js.indexOf('</script>') > 0) {
        window.$(document.body).append(window.$(js));
    } else {
        let dom = document.createElement("script");
        dom.type = "text/javascript";
        dom.text = js;
        document.body.appendChild(dom);
    }
}
//等保,type==1说明需要验证,val是要验证的值,返回true验证通过，否则给出提示语
function guarantee (type, val) {
    var regTest = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d$@$!%*#?&~^()-+=<>]{6,16}$/;
    var msg = '密码必须包含数字和大小写字母任意两种组合，长度6-16位';
    if (type == 1) {
        if (!regTest.test(val)) {
            return msg;
        }
        else {
            return true;
        }
    }
    else {
        return true;
    }
}
function isText (_value) {//字符串是空就输出空，防止undefined
    _value = "" + _value;
    if (_value == "null" || _value == null || _value == "" || _value == "undefined") {
        return '';
    }
    return _value;
}
// 带提示表格头的渲染器
function gridHeadRender (label, content, sortable = false) {
    return (h) => {
        let sortableElement = h("span", {
            class: 'caret-wrapper'
        }, [
            h('i', {
                class: 'sort-caret ascending'
            }),
            h('i', {
                class: 'sort-caret descending'
            })
        ]);
        return h("section", [
            h("span", {}, label),
            sortable ? sortableElement : '',
            h(
                "el-tooltip",
                {
                    props: {
                        content,
                        "max-width": 250,
                        transfer: true,
                    },
                },
                [
                    h("i", {
                        class: "el-icon-question",
                        style: 'color: #FCB723;font-size: 16px;'
                    }),
                ]
            ),
        ]);
    };
}

function getScreenHeight () {
    let div = document.createElement("div");
    div.style.position = "fixed";
    div.style.top = "0";
    div.style.right = "0";
    div.style.bottom = "0";
    div.style.left = "0";
    div.style.zIndex = "-1";
    document.body.appendChild(div);
    let height = div.clientHeight;
    document.body.removeChild(div);
    return height;
}

export default {
    calcPrice,
    tsToTime,
    dislodgeZero,
    getWeek,
    timestampToDay,
    timestampToMD,
    timestampToHM,
    time_judge,
    getDuration,
    debounce,
    throttle,
    getLetterNumber,
    toFixed,
    swapArrayItem,
    joinArray,
    getCurTimestamp,
    clearObj,
    stopBodyScroll,
    appendJs,
    guarantee,
    isText,
    gridHeadRender,
    timeMeter,
    getScreenHeight,
};


// WEBPACK FOOTER //
// ./src/utils/plugins.js